<!-- Modal de reprocesso de registro DIVERGENTE (item 1): decisao + motivo obrigatorio -->
<ng-template #reprocDivTpl>
  <p style="margin-bottom: 8px;">
    Este registro está <strong>divergente</strong>. Reprocessar mesmo assim baixa o
    título ignorando a divergência.
  </p>
  <p style="margin-bottom: 6px;">Informe o motivo da decisão (obrigatório):</p>
  <textarea nz-input [(ngModel)]="reprocMotivo" rows="3"
            placeholder="Ex.: divergência de R$ 0,02 por arredondamento; aprovado por Fulano."></textarea>
</ng-template>

<div class="registro-detail" *ngIf="registro">
  <!-- Status Header -->
  <div class="detail-status-header">
    <nz-tag [nzColor]="liberadoColor" class="status-tag-large">
      {{ registro.LIBERADO || 'Pendente' }}
    </nz-tag>
    <span class="detail-id">#{{ registro.IDREGISTRO }}</span>
  </div>

  <!-- Actions -->
  <div class="detail-actions">
    <button
      nz-button
      nzType="primary"
      nzSize="small"
      [nzLoading]="processing"
      (click)="onReprocessar()"
      [disabled]="!tipoConfig?.IDCONF">
      <span nz-icon nzType="thunderbolt"></span> Reprocessar
    </button>
    <button
      nz-button
      nzType="default"
      nzSize="small"
      [nzLoading]="processing"
      (click)="onLiberarManual()"
      [disabled]="registro.LIBERADO === 'Liberado'">
      <span nz-icon nzType="check"></span> Liberar Manual
    </button>
  </div>

  <nz-divider></nz-divider>

  <!-- Valores -->
  <nz-descriptions nzTitle="Valores" nzBordered nzSize="small" [nzColumn]="2">
    <nz-descriptions-item *ngIf="campoVisivel('VLRTOT')" nzTitle="Valor Total">
      {{ registro.VLRTOT | number:'1.2-2' }}
    </nz-descriptions-item>
    <nz-descriptions-item *ngIf="campoVisivel('VLRLIQ')" nzTitle="Valor Líquido">
      {{ registro.VLRLIQ | number:'1.2-2' }}
    </nz-descriptions-item>
    <nz-descriptions-item nzTitle="Taxa">
      {{ registro.VLRTAXA | number:'1.2-2' }}
    </nz-descriptions-item>
    <nz-descriptions-item nzTitle="Taxa Ant.">
      {{ registro.VLRTAXAANT | number:'1.2-2' }}
    </nz-descriptions-item>
    <nz-descriptions-item *ngIf="campoVisivel('VLRPREV')" nzTitle="Provisão">
      <span [style.fontWeight]="'600'" [style.color]="registro.VLRPREV ? '#52c41a' : '#8c8c8c'">
        {{ registro.VLRPREV | number:'1.2-2' }}
      </span>
    </nz-descriptions-item>
  </nz-descriptions>

  <!-- Identificação -->
  <nz-descriptions nzTitle="Identificação" nzBordered nzSize="small" [nzColumn]="2" class="section-descriptions">
    <nz-descriptions-item *ngIf="campoVisivel('SEQUENCIA')" nzTitle="Sequência">{{ registro.SEQUENCIA }}</nz-descriptions-item>
    <nz-descriptions-item *ngIf="campoVisivel('TIPO')" nzTitle="Tipo">
      <nz-tag nzColor="purple" *ngIf="registro.TIPO">{{ registro.TIPO }}</nz-tag>
      <span *ngIf="!registro.TIPO">—</span>
    </nz-descriptions-item>
    <nz-descriptions-item *ngIf="campoVisivel('NSU')" nzTitle="NSU">{{ registro.NSU || '—' }}</nz-descriptions-item>
    <nz-descriptions-item nzTitle="TID">{{ registro.TID || '—' }}</nz-descriptions-item>
    <nz-descriptions-item nzTitle="Autorização">{{ registro.NUAUT || '—' }}</nz-descriptions-item>
    <nz-descriptions-item *ngIf="campoVisivel('PEDIDO')" nzTitle="Pedido">{{ registro.PEDIDO || '—' }}</nz-descriptions-item>
    <nz-descriptions-item *ngIf="campoVisivel('NOTA')" nzTitle="Nota">{{ registro.NOTA || '—' }}</nz-descriptions-item>
    <nz-descriptions-item nzTitle="Estab.">{{ registro.ESTABELECIMENTO || '—' }}</nz-descriptions-item>
  </nz-descriptions>

  <!-- Cartão -->
  <nz-descriptions nzTitle="Cartão" nzBordered nzSize="small" [nzColumn]="2" class="section-descriptions">
    <nz-descriptions-item nzTitle="Cartão">{{ registro.NUCARTAO || '—' }}</nz-descriptions-item>
    <nz-descriptions-item nzTitle="Bandeira">{{ registro.BANDEIRA || '—' }}</nz-descriptions-item>
    <nz-descriptions-item nzTitle="Modalidade">{{ registro.MODALIDADE || '—' }}</nz-descriptions-item>
    <nz-descriptions-item nzTitle="Parcelas">
      {{ registro.PARCELA || '—' }} / {{ registro.QTDPARCELA || '—' }}
    </nz-descriptions-item>
  </nz-descriptions>

  <!-- Datas -->
  <nz-descriptions nzTitle="Datas" nzBordered nzSize="small" [nzColumn]="2" class="section-descriptions">
    <nz-descriptions-item *ngIf="campoVisivel('DATADOC')" nzTitle="Data Documento">{{ registro.DATADOC || '—' }}</nz-descriptions-item>
    <nz-descriptions-item nzTitle="Data Recebimento">{{ registro.DATAREC || '—' }}</nz-descriptions-item>
  </nz-descriptions>

  <!-- Vinculação ERP -->
  <nz-descriptions nzTitle="Vinculação ERP" nzBordered nzSize="small" [nzColumn]="2" class="section-descriptions">
    <nz-descriptions-item *ngIf="campoVisivel('NUNOTA')" nzTitle="NUNOTA">{{ registro.NUNOTA || '—' }}</nz-descriptions-item>
    <nz-descriptions-item nzTitle="NUFIN">{{ registro.NUFIN || '—' }}</nz-descriptions-item>
    <nz-descriptions-item nzTitle="NUFIN Novo">{{ registro.NUFINNOVO || '—' }}</nz-descriptions-item>
    <nz-descriptions-item nzTitle="NSII">{{ registro.NSII || '—' }}</nz-descriptions-item>
  </nz-descriptions>

  <!-- Campos adicionais: colunas extras incluidas no grid (COLUNASGRADE), pra o
       detalhe refletir a grade -->
  <nz-descriptions
    *ngIf="colunasExtras?.length"
    nzTitle="Campos adicionais"
    nzBordered
    nzSize="small"
    [nzColumn]="2"
    class="section-descriptions">
    <nz-descriptions-item *ngFor="let ec of colunasExtras" [nzTitle]="extraLabel(ec)">
      {{ extraValor(ec.key) }}
    </nz-descriptions-item>
  </nz-descriptions>

  <!-- Config do Tipo -->
  <div class="tipo-config-section" *ngIf="tipoConfig">
    <nz-divider nzText="Configuração do Tipo" nzOrientation="left"></nz-divider>
    <nz-descriptions nzBordered nzSize="small" [nzColumn]="2">
      <nz-descriptions-item nzTitle="Configuração (IDCONF)">
        {{ tipoConfig.IDCONF ? '#' + tipoConfig.IDCONF : 'Não configurado' }}
      </nz-descriptions-item>
      <nz-descriptions-item nzTitle="Negociação">
        {{ tipoConfig.TIPONEG || '—' }}
      </nz-descriptions-item>
      <nz-descriptions-item nzTitle="% Neg.">
        {{ tipoConfig.PERCNEG != null ? tipoConfig.PERCNEG + '%' : '—' }}
      </nz-descriptions-item>
      <nz-descriptions-item nzTitle="Valor Neg.">
        {{ tipoConfig.VLRNEG != null ? (tipoConfig.VLRNEG | number:'1.2-4') : '—' }}
      </nz-descriptions-item>
    </nz-descriptions>
  </div>
</div>
